// React Query
import { UseQueryResult } from '@tanstack/react-query';
// Http Methods
import { getRequest as get } from '../utils/HttpMethods';
// Interface
import { Status, isStatus } from 'interfaces';
import { useListQuery } from '../utils/queries';

export const statusQueryKeys = {
  all: ['status'],
};

/**
 * @description Fetches the list of statuses from the server.
 * @returns {Promise<Status[]>} A promise that resolves to an array of Status objects.
 */
export const listStatus = async (): Promise<Status[]> =>
  await get<Status[]>('QBilling', `/resource/status/all`);

/**
 * @description Hook to fetch the list of statuses using React Query.
 * @param {Object} params - Parameters for the hook.
 * @param {boolean} [params.displayNotification=false] - Whether to display a notification on query success or failure.
 * @returns {UseQueryResult<Status[], Error>} The result of the query.
 */
export const useListStatus = ({
  displayNotification = false,
}: {
  displayNotification?: boolean;
}): UseQueryResult<Status[], Error> => {
  return useListQuery<Status>({
    queryKey: statusQueryKeys.all,
    fetchFunction: listStatus,
    enabled: true,
    functionName: 'listStatus',
    isEntity: isStatus,
    displayNotification,
    staleTime: 1000 * 60 * 30,
    gcTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
